import BidWinningLabel from '../../../../elements/BidWinningLabel/BidWinningLabel'
import BidOutbidLabel from '../../../../elements/BidOutbidLabel/BidOutbidLabel'
import C from '../../../../utilities/constants'

const {
  STATUS: { WON, WINNING, OUTBID, LOST, SOLD, CLOSED },
} = C

const BID_STATUS: any = {
  [WON]: <BidWinningLabel>Won</BidWinningLabel>,
  [WINNING]: <BidWinningLabel />,
  [OUTBID]: <BidOutbidLabel />,
  [LOST]: <BidOutbidLabel>Lost</BidOutbidLabel>,
  [SOLD]: <BidOutbidLabel>Sold</BidOutbidLabel>,
  [CLOSED]: (
    <BidOutbidLabel>
      <span className="font-bold text-base">
        This item is no longer available.
      </span>
    </BidOutbidLabel>
  ),
}

const BidStatus = ({
  bidStatus,
  itemClosed,
  itemRemoved,
  className = `absolute top-2.5 left-1.5`,
}: any) => {
  if (!bidStatus) {
    if (itemClosed) return <div className={className}>{BID_STATUS[SOLD]}</div>
    if (itemRemoved)
      return <div className={className}>{BID_STATUS[CLOSED]}</div>
    else return <></>
  }
  return <div className={className}>{BID_STATUS[bidStatus]}</div>
}

export default BidStatus
